<template>
  <ScipherLayout>
    <template #menu>
      <FixedPlaceholder :class="{ disabled: isLoading }" :component="tabMenu" v-model="liveFilters" @input="filterChanged" v-if="tabMenu" />
    </template>
    <div class="hvh-flex column grow-1" v-if="cohort">
      <CohortHeader class="mx-4 px-3 my-3" v-model="cohort" :options="options" v-on="cohortListOns" />
      <CohortTabs v-model="selectedTab" :items="tabs" />
      <component class="grow-1" :is="tabs[selectedTab].component" :cohort.sync="cohort" :originalCohort="originalCohort" :predefinedCohorts="filteredCohorts" :options="options" v-model="liveFilters" @save="save" />
    </div>
    <Loader v-if="isLoading" />
  </ScipherLayout>
</template>

<script>
import axios from '../../../axios';
import ScipherLayout from '../../../components/analytics/layout/ScipherLayout.vue';
import FixedPlaceholder from '../../../components/common/fixedPlaceholder/FixedPlaceholder.vue';
import CohortHeader from '../../../components/analytics/cohorts/CohortHeader.vue';
import CohortTabs from '../../../components/analytics/cohorts/CohortTabs.vue';
import CohortPatientDemographicLeftMenu from '../../../components/cohorts/CohortPatientDemographicLeftMenu.vue';
import PatientDemographic from './tabs/PatientDemographic.vue';
import PatientDefinition from './tabs/PatientDefinition.vue';
import { createFormData, errorDebug } from '../../../libraries/common';
import { confirmClinicalVerification } from '../../../libraries/cohorts';
export default {
  components: { ScipherLayout, FixedPlaceholder, CohortHeader, CohortTabs, },
  data() {
    return {
      cohort: null,
      originalCohort: null,
      options: null,
      isLoading: false,
      liveFilters: {
        area: {},
      },
      tabs: {
        'Patient Definition': {
          icon: 'mdi-account',
          component: PatientDefinition,
        },
        'Patient Demographic': {
          menu: CohortPatientDemographicLeftMenu,
          component: PatientDemographic,
        },
      },
      predefinedCohorts: null,
    };
  },
  computed: {
    cohortListOns() {
      var item = this.cohort;
      return {
        'pin-cohort': this.pinCohort.bind(this, item),
        archive: this.archive.bind(this, item),
        'archive-all-versions': this.archiveAllVersions.bind(this, item),
        'copy-url': () => this.copyUrl(item),
        'hide-cohort': this.hideCohort.bind(this, item),
        'clinically-verify': this.clinicallyVerify.bind(this, item),
        'ask-clinically-verify': this.askClinicallyVerify.bind(this, item),
        'new-analysis': this.newAnalysis.bind(this, item),
      };
    },
    selectedTab: {
      get() {
        var routeTab = (this.$route.params.tab || 'Patient-Demographic').replaceAll('-', ' ');
        return Object.keys(this.tabs)
          .find(f => f === routeTab);
      },
      set(value) {
        if (value !== this.selectedTab) {
          var routeTab = value.replaceAll(' ', '-');
          this.$router.replace({ name: 'cohortTab', params: { ...this.$route.params, tab: routeTab } });
        }
      },
    },
    tabMenu() {
      return this.tabs[this.selectedTab].menu;
    },
    filteredCohorts() {
      return (this.predefinedCohorts || [])
        .filter(f => f.patientDatasource === this.options.patientDataSourceId);
    },
  },
  methods: {
    loadData() {
      this.isLoading = true;

      var loadOptions = axios
        .get('/Analytics/Cohorts/Options')
        .then(({ data }) => (this.options = { ...this.options, ...data }))
        .catch(errorDebug);

      var loadCohortOptions = axios
        .get(`/Analytics/Cohorts/${this.$route.params.id}/Options`)
        .then(({ data }) => this.options = { ...this.options, ...data })
        .catch(errorDebug);

      var loadCohort = axios
        .get(`/Analytics/Cohorts/${this.$route.params.id}`)
        .then(({ data }) => {
          this.cohort = data;
          this.originalCohort = data;
        })
        .catch(errorDebug);


      Promise.all([loadOptions, loadCohortOptions, loadCohort])
        .then(() => this.isLoading = false);
    },

    pinCohort(item, shouldPin) {
      this.isLoading = true;
      axios
        .post(`/Analytics/Cohorts/${item.id}/PinCohort`, shouldPin)
        .then(() => this.$set(item, 'isPinned', shouldPin))
        .catch(errorDebug)
        .then(() => (this.isLoading = false));
    },
    copyUrl() {
      navigator.clipboard.writeText(location.href);
      this.$notify('Url copied to the clipboard!');
    },
    clinicallyVerify(item, shouldVerify) {
      this.isLoading = true;
      axios
        .post(`/Analytics/Cohorts/${item.id}/ClinicallyVerify`, shouldVerify)
        .then(({ data }) => {
          this.$set(item, 'cohortVerified', shouldVerify ? data : null);
          this.$set(item, 'cohortVerificationPending', false);
        })
        .catch(errorDebug)
        .then(() => (this.isLoading = false));
    },
    askClinicallyVerify(item) {
      confirmClinicalVerification.call(this)
        .then(() => {
          this.isLoading = true;
          axios
            .post(`/Analytics/Cohorts/${item.id}/AskClinicallyVerification`)
            .then(() => {
              this.$set(item, 'cohortVerificationPending', true);
              if (this.searchedCohorts.includes(item)) {
                this.searchedCohorts = [...this.searchedCohorts];
              }
            })
            .catch(errorDebug)
            .then(() => (this.isLoading = false));
        })
        .catch(() => null);
    },
    hideCohort(item, shouldHide) {
      this.isLoading = true;
      axios
        .post(`/Analytics/Cohorts/${item.id}/HideCohort`, shouldHide)
        .then(() => this.$set(item, 'isPrivate', shouldHide))
        .catch(errorDebug)
        .then(() => (this.isLoading = false));
    },
    archive(item) {
      this.isLoading = true;
      axios
        .post(`/Analytics/Cohort/Archive`, createFormData({ cohortIds: [item.id] }))
        .then(this.redirect)
        .catch(errorDebug)
        .then(() => (this.isLoading = false));
    },
    archiveAllVersions(item) {
      this.isLoading = true;
      axios
        .post(`/Analytics/Cohort/ArchiveAllVersions`, createFormData({ versionGroupIds: [item.versionGroupId] }))
        .then(() => this.redirect)
        .catch(errorDebug)
        .then(() => (this.isLoading = false));
    },
    redirect() {
      this.$router.replace({ name: 'cohorts' });
    },
    newAnalysis(item) {
      this.goTo(`/Analytics/Cohort/${item.id}/Run`);
    },
    filterChanged(obj) {
      this.liveFilters = {
        ...this.liveFilters,
        ...obj,
      };
    },
    save() {
      var model = {
        ...this.cohort,
        patientDatasource: this.options.patientDataSourceId,
        // forceRegenerate: true,
      };
      this.isLoading = true;
      axios.post('/Analytics/Cohort/Save', model)
        .then(() => {
          this.originalCohort = this.cohort;
          this.$notify('Cohort saved successufully.');
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  watch: {
    '$route.params.id'() {
      this.loadData();
    },
  },
  created() {
    if (!this.getFlag('DAS-755')) {
      this.$store.state.isAppLoading = true;
      location.replace(`/Analytics/Cohort/${this.$route.params.id}/Overview?actics=1`);
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohort'] = this;

    if (this.getFlag('DAS-755')) {
      this.loadData();

      axios.get('/Analytics/Cohort/PredefinedCohorts')
        .then(({ data }) => this.predefinedCohorts = data);
    }
  },
};
</script>
